export default "__VITE_ASSET__df59a220__"